/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const GetPersonalHealthRecordZipExportResponseTypename = "GetPersonalHealthRecordZipExportResponse" as const;

/**
 *
 * @export
 * @interface GetPersonalHealthRecordZipExportResponse
 */
export interface GetPersonalHealthRecordZipExportResponse {
  /**
   *
   * @type {string}
   * @memberof GetPersonalHealthRecordZipExportResponse
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonalHealthRecordZipExportResponse
   */
  status: GetPersonalHealthRecordZipExportResponseStatusEnum;
  /**
   *
   * @type {Array<string>}
   * @memberof GetPersonalHealthRecordZipExportResponse
   */
  types?: Array<GetPersonalHealthRecordZipExportResponseTypesEnum>;
  /**
   *
   * @type {string}
   * @memberof GetPersonalHealthRecordZipExportResponse
   */
  url?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof GetPersonalHealthRecordZipExportResponse
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum GetPersonalHealthRecordZipExportResponseStatusEnum {
  Initialized = "initialized",
  Processing = "processing",
  Generated = "generated",
  Failed = "failed",
  Nothing = "nothing",
} /**
 * @export
 * @enum {string}
 */
export enum GetPersonalHealthRecordZipExportResponseTypesEnum {
  Medication = "medication",
  SpecificHealthCheckup = "specific_health_checkup",
  MedicalExpenseNotification = "medical_expense_notification",
}

export function GetPersonalHealthRecordZipExportResponseFromJSON(json: any): GetPersonalHealthRecordZipExportResponse {
  return GetPersonalHealthRecordZipExportResponseFromJSONTyped(json, false);
}

export function GetPersonalHealthRecordZipExportResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetPersonalHealthRecordZipExportResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: GetPersonalHealthRecordZipExportResponseTypename,

    id: !exists(json, "id") ? undefined : json["id"],
    status: json["status"],
    types: !exists(json, "types") ? undefined : json["types"],
    url: !exists(json, "url") ? undefined : json["url"],
  };
}

export function GetPersonalHealthRecordZipExportResponseToJSON(
  object?: GetPersonalHealthRecordZipExportResponse | null
): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    id: value.id,
    status: value.status,
    types: value.types,
    url: value.url,
  };
}
